const dataGridStyles = {
    '& .MuiDataGrid-cell:focus-within': {
        outline: 'none',
    },
    '& .MuiDataGrid-cell:hover': {
        backgroundColor: 'none',
    },
    '& .header-class': {
        backgroundColor: '#ccc',
    },
    '& .MuiDataGrid-row': {
        cursor: 'pointer',
    },
    '& .MuiDataGrid-cell': {
        display: 'flex',
        alignItems: 'center',
    },
    '& .MuiDataGrid-columnHeaderTitleContainer': {
        backgroundColor: '#ccc',
        borderBottom: 'none',
    },
    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
};

export default dataGridStyles;